export default __webpack_public_path__ + "images/BA.6850013.png";